import { createFileRoute } from '@tanstack/react-router';

import { BulkUploadImportHistoryPage } from '~pages/parents/bulk-upload/history';

export const Route = createFileRoute(
  '/_auth/_layout/parents/bulk-upload/history',
)({
  component: BulkUploadImportHistoryPage,
});
